import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const vmTemplateDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.addVmTemplate',
        popover: {
          title: 'Create New VM Template',
          description:
            'Click here to create a new virtual machine template. Templates allow you to standardize configurations for faster and more consistent VM deployments.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.editVmTemplate',
        popover: {
          title: 'Edit VM Template',
          description:
            'Use this option to modify an existing VM template. Ensure that any changes align with your organization’s requirements before saving.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.deleteVmTemplate',
        popover: {
          title: 'Delete VM Template',
          description:
            'Remove a VM template that is no longer needed. Be cautious, as deleting a template is irreversible.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.vmTemplateMainTableData',
        popover: {
          title: 'VM Template Management Table',
          description:
            'This table provides an overview of all VM templates. You can manage, edit, or delete templates as needed to ensure your VM deployments remain efficient.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default vmTemplateDriverObj;
